import { useState } from "react";
import {
  LeagueRegistrationForm,
  type LeagueParticipantType,
} from "../components/LeagueRegistrationForm";

export function RegisterPage() {
  const [participantType, setParticipantType] =
    useState<LeagueParticipantType>("regular");

  return (
    <main id="top" className="register-page">
      <section className="register-hero" aria-labelledby="register-title">
        <div className="register-shell">
          <p className="league-kicker">
            AIYSS / AI COMPETITION LEAGUE / REGISTRATION
          </p>
          <h1 id="register-title">リーグに登録する。</h1>
          <p>登録情報を確認し、KaggleのBio認証を経てリーグへ登録します。</p>
        </div>
      </section>
      <section
        className="register-content"
        aria-labelledby="register-form-title"
      >
        <div className="register-shell">
          <div className="register-heading">
            <p className="league-eyebrow">REGISTRATION FORM</p>
            <h2 id="register-form-title">AIYSS AI Competition League</h2>
            <p>
              参加区分を選び、登録情報を入力してください。次に内容を確認し、KaggleのBioへ認証キーを追加して本人確認を行います。
            </p>
          </div>
          <div
            className="register-type-switcher"
            role="tablist"
            aria-label="参加区分"
          >
            <button
              className={participantType === "regular" ? "is-active" : ""}
              type="button"
              role="tab"
              aria-selected={participantType === "regular"}
              onClick={() => setParticipantType("regular")}
            >
              中高生として登録
            </button>
            <button
              className={participantType === "university" ? "is-active" : ""}
              type="button"
              role="tab"
              aria-selected={participantType === "university"}
              onClick={() => setParticipantType("university")}
            >
              大学生として登録
            </button>
            <button
              className={participantType === "graduate" ? "is-active" : ""}
              type="button"
              role="tab"
              aria-selected={participantType === "graduate"}
              onClick={() => setParticipantType("graduate")}
            >
              大学院生として登録
            </button>
            <button
              className={participantType === "professional" ? "is-active" : ""}
              type="button"
              role="tab"
              aria-selected={participantType === "professional"}
              onClick={() => setParticipantType("professional")}
            >
              社会人として登録
            </button>
          </div>
          <p className="register-type-description">
            {participantType === "graduate"
              ? "大学院生は1〜5年から学年を選択し、総合ランキングと大学院生部門に表示されます。"
              : participantType === "professional"
              ? "社会人はエキシビション総合に、社会人カテゴリーとして表示されます。"
              : participantType === "university"
              ? "大学生部門として表示します。大学1〜4年から選択してください。高専4年は大学1年、高専5年は大学2年として扱います。"
              : "中学生・高校生の通常参加です。高専4・5年生は大学生扱いとなります。学年は現在の学年を選択してください。"}
          </p>
          <LeagueRegistrationForm
            key={participantType}
            participantType={participantType}
          />
          <a className="register-back-link" href="/league/">
            ← 年間リーグの説明へ戻る
          </a>
        </div>
      </section>
    </main>
  );
}
